import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import { config } from '../config';
import { bindRealtimeAuth } from './realtimeAuth';

let _supabase: SupabaseClient | null = null;

/**
 * anon key 클라이언트. 채널은 전부 비공개라 구독 전에 백엔드가 준 단명 토큰을 붙여야 한다 —
 * `subscribeWhenAuthed` 가 그 순서를 지킨다(ADR-0036).
 */
export function getSupabase(): SupabaseClient {
  if (!_supabase) {
    _supabase = createClient(config.supabaseUrl, config.supabaseAnonKey, {
      realtime: {
        params: {
          eventsPerSecond: 10,
        },
      },
      auth: {
        persistSession: true,
        autoRefreshToken: true,
      },
    });
    bindRealtimeAuth(_supabase);
  }
  return _supabase;
}
